import { getIconByName } from '../sidebar_icon_mapper';

export interface OrganizationLogoProps {
  logo?: string;
  orgName: string;
  isSidebarOpen: boolean;
}

export function OrganizationLogo({ logo, orgName, isSidebarOpen }: OrganizationLogoProps) {
  const sizeClass = isSidebarOpen ? 'h-9 w-9 text-sm' : 'h-12 w-12 text-lg';

  if (!logo) {
    return (
      <div
        className={`bodySm flex items-center justify-center rounded-lg border border-primaryDefault bg-successExtraLight font-semibold transition-all duration-700 ease-in-out ${sizeClass}`}
      >
        {orgName.substring(0, 2).toUpperCase()}
      </div>
    );
  }

  const isUrl = typeof logo === 'string' && (logo.startsWith('http') || logo.startsWith('/'));

  if (isUrl) {
    return (
      <img
        src={logo}
        alt={orgName}
        className="h-full w-full rounded-lg object-cover transition-all duration-700 ease-in-out"
        onError={(e) => (e.currentTarget.style.display = 'none')}
      />
    );
  }

  return getIconByName(logo, 'w-full h-full transition-all duration-700 ease-in-out');
}
